import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "What is BDIX hosting and why is it important?",
    answer: "BDIX (Bangladesh Internet Exchange) hosting provides ultra-fast connectivity within Bangladesh by routing traffic through local exchange points. This results in significantly lower latency and faster page load times for visitors within Bangladesh, making it ideal for local businesses and websites targeting Bangladeshi audiences.",
  },
  {
    question: "Do you offer free website migration?",
    answer: "Yes! We offer completely free website migration for all our hosting plans. Our expert team will migrate your website, databases, emails, and all files from your current host to our servers with zero downtime.",
  },
  {
    question: "What control panel do you use?",
    answer: "We use cPanel, the industry's most popular and user-friendly control panel. It provides an intuitive interface for managing your website, emails, databases, files, and more. We also offer one-click installers for WordPress, Joomla, and 400+ other applications.",
  },
  {
    question: "What is your uptime guarantee?",
    answer: "We guarantee 99.99% uptime for all our hosting services, backed by our Service Level Agreement (SLA). Our state-of-the-art datacenter infrastructure, redundant power systems, and 24/7 monitoring ensure your website stays online.",
  },
  {
    question: "Do you provide daily backups?",
    answer: "Yes, we perform automated daily backups of all hosting accounts. Backups are stored on separate servers for added security. You can also create manual backups anytime through cPanel or request restoration from our support team.",
  },
  {
    question: "How fast is your customer support?",
    answer: "Our customer support team is available 24/7 via live chat, phone, and ticket system. Average response time for live chat is under 2 minutes, and most tickets are resolved within 1 hour. Our support team consists of certified hosting experts.",
  },
];

const FAQSection = () => {
  return (
    <section className="py-20 bg-muted/30">
      <div className="container-custom">
        <div className="text-center mb-16 animate-fade-in-up">
          <span className="inline-block px-4 py-1.5 rounded-full bg-blue-50 text-primary text-sm font-medium mb-4">
            FAQ
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Find answers to common questions about our hosting services.
          </p>
        </div>

        <div className="max-w-3xl mx-auto animate-fade-in-up animation-delay-200">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-card border border-border rounded-xl px-6 data-[state=open]:shadow-md transition-shadow"
              >
                <AccordionTrigger className="text-left text-foreground hover:no-underline py-4">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground pb-4">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
